import './App.css';
import { useEffect } from 'react';
import CasebookConnect from './CasebookConnect';
import { removeIdbUserBook } from './app/models/db';
import { getUA, browserName, osName, osVersion } from 'react-device-detect';
function App() {
    const userVO = localStorage.getItem('userVO') ? JSON.parse(localStorage.getItem('userVO')) : null;
    const nodeName = window.Configs.REACT_APP_NODE_NAME;
    const enviVal = window.Configs.REACT_APP_ENVIRONMENT;
    const baseURL = window.Configs.REACT_APP_FULL_BASE_URL;
    const REACT_APP_GTM_CODE = window.Configs.REACT_APP_GTM_CODE;
    const enviURL = (enviVal === 'BETA' ? "https://dev.casebookconnect.com/" : baseURL) + 'wkconnects/rest';
    const qpApiURL = (enviVal === 'BETA' ? "https://dev.casebookconnect.com/" : baseURL) + 'quizzing-platform';
    localStorage.setItem("ENV", enviURL);
    localStorage.setItem("qpAPI", qpApiURL);
    localStorage.setItem("BASE_URL", baseURL);
    localStorage.setItem("reactNodeName", nodeName);
    localStorage.setItem("browserName", browserName);
    localStorage.setItem("deviceOS", osName + ' ' + osVersion);
    if (getUA.indexOf("Windows NT 6.2") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 6.1") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 6.0") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 5.1") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 5.0") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 6.3") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Windows NT 10.0") !== -1) { localStorage.setItem("deviceType", 'Desktop'); }
    else if (getUA.indexOf("Macintosh") !== -1) { localStorage.setItem("deviceType", 'Mac Desktop'); }
    else if (getUA.indexOf("iPad") !== -1) { localStorage.setItem("deviceType", 'iPad'); }
    else if (getUA.indexOf("iPhone") !== -1) { localStorage.setItem("deviceType", 'iPhone'); }
    else if (getUA.indexOf("Android") !== -1) { localStorage.setItem("deviceType", 'Android Tablet'); }
    else if (getUA.indexOf("X11") !== -1) { 
        localStorage.setItem("deviceType", 'deviceTypeUnknown'); 
    }
    useEffect(async () => {
        if (userVO) {
            const { userId } = userVO
            removeIdbUserBook('offlineApp', { userId });
        }
    }, [userVO]);

    useEffect(async () => {
        document.body.prepend(
            document.createRange().createContextualFragment(`
            <!-- Google Tag Manager (noscript) -->
            <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${REACT_APP_GTM_CODE}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
            <!-- End Google Tag Manager (noscript) -->
          `)
          );
    }, []);

    return (
        <div className="App">
            <CasebookConnect />
        </div>
    );
}
export default App;
